export class search_filter{
    textColumn!: string[];
    textValue!: string[];   
    SeachType!: string;
}